import { render, staticRenderFns } from "./Lift.vue?vue&type=template&id=098ebba0"
import script from "./Lift.vue?vue&type=script&lang=js"
export * from "./Lift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports